export default class lomaSettingsClass {
  constructor() {
    this.tableCell = { fullHeight: true, showPrefix: false };
  }
  init() {
    const a = localStorage.getItem("lomaSettings");
    if (a) {
      const b = JSON.parse(a);
      this.tableCell = b.tableCell;
    }
  }
  static save(lomaSettings) {
    localStorage.setItem("lomaSettings", JSON.stringify(lomaSettings));
  }
}
